package com.nonopn.skywatcher.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.app.home.LocalAppBarProvider
import com.nonopn.skywatcher.common.app.pages.profile.ProfileContent
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavBackStackEntryWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteProfile : RouteParameterTo

object RouterProfile : RouterNoParameters<RouteProfile> {
    override val klass = RouteProfile::class

    override fun navigateTo() = NavigateTo(
        route = RouteProfile,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteProfile

    override fun route(navBackStackEntry: NavBackStackEntryWrapper) =
        RouteProfileImpl()

    override fun isMatching(route: String) = route == "/profile"

    override fun navigateFrom(path: String) = RouteProfile
}

class RouteProfileImpl : Route<RouteProfile>(
    route = "/profile",
    params = RouteProfile,
) {
    @Composable
    override fun scene() {
        val provider = LocalAppBarProvider.current
        LaunchedEffect(provider) {
            onInternalEntryIsActive(
                provider,
                emptyList()
            )
        }

        ProfileContent(Modifier.fillMaxSize())
    }

    private fun onInternalEntryIsActive(
        model: AppBarStateProvider,
        defaultActions: List<MenuItem>,
    ): String {
        model.setAppBarState(
            AppBarState.Regular(
                title = "Profile",
                defaultActions
            )
        )

        return "/profile"
    }
}
